import { useState } from 'react'
import DrawerList from './DrawerList'
import { Drawer } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import MenuIcon from '@material-ui/icons/Menu'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { useSession } from '../../../context/SessionContext'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  })
)

/**
 * Custom `AdminAppBar` component declaration.
 * Define style and functionalities to AdminAppBar 
 * @return AdminAppBar
*/
const AdminAppBar = (): JSX.Element => {
  const classes = useStyles()
  const { autenticated, user, logout } = useSession()
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  return (
    <div className={classes.root}>
      <Drawer anchor={'left'} open={showDrawer} onClose={() => setShowDrawer(false)}>
        <DrawerList setShowDrawer={setShowDrawer} />
      </Drawer>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            onClick={() => setShowDrawer(true)}
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <MenuIcon />
          </IconButton>
          {user && (
            <Typography variant="h6" className={classes.title}>
              {user.username}
            </Typography>
          )}
          {autenticated && (
            <Button
              color="inherit"
              onClick={() => {
                if (logout) logout()
              }}
            >
              CERRAR SESIÓN
            </Button>
          )}
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default AdminAppBar